import { ActionIcon, createStyles, Group, Table, Tooltip } from "@mantine/core";
import { IconPencil, IconTrash } from "@tabler/icons-react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const useStyles = createStyles((theme) => ({
  editButton: {
    color: theme.colors.green[6],
    background: "transparent",

    "&:hover": {
      background:
        theme.colorScheme === "dark"
          ? theme.colors.dark[5]
          : theme.colors.green[0],
    },
  },

  deleteButton: {
    color: theme.colors.red[6],
    background: "transparent",

    "&:hover": {
      background:
        theme.colorScheme === "dark"
          ? theme.colors.dark[5]
          : theme.colors.red[0],
    },
  },
}));

const EmailListTable = ({ data, onDelete, onEdit, emailHeader, actionsHeader }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <Table striped highlightOnHover withBorder>
      <thead>
        <tr>
          <th>{emailHeader || t("emailListTable.emailHeader")}</th>
          <th style={{ width: 120 }}>{actionsHeader || t("emailListTable.actionsHeader")}</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((row) => (
          <tr key={row?.email}>
            <td>{row?.email}</td>
            <td>
              <Group spacing="xs" noWrap>
                {onEdit && (
                  <Tooltip label="Edit Email" withArrow>
                    <ActionIcon
                      variant="subtle"
                      radius="md"
                      className={classes.editButton}
                      aria-label={`edit-${row?.email}`}
                      onClick={() => onEdit(row?.email)}
                    >
                      <IconPencil size={20} />
                    </ActionIcon>
                  </Tooltip>
                )}
                <Tooltip label="Delete Email" withArrow>
                  <ActionIcon
                    variant="subtle"
                    radius="md"
                    className={classes.deleteButton}
                    aria-label={`delete-${row?.email}`}
                    onClick={() => onDelete(row?.email)}
                  >
                    <IconTrash size={20} />
                  </ActionIcon>
                </Tooltip>
              </Group>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

EmailListTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string.isRequired,
    })
  ),
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  emailHeader: PropTypes.string,
  actionsHeader: PropTypes.string,
};

export default EmailListTable;
